import * as React from "react";
import { cn } from "../../lib/utils";
import {
  NUMERAL_EN,
  NUMERAL_FA,
} from "../../app/providers/NumberFormatProvider";

/**
 * Compact EN / FA segmented control for the global numeral system.
 */
function NumeralSystemToggle({ value, onChange, className, collapsed = false }) {
  const options = [
    { id: NUMERAL_EN, label: "EN", title: "Latin numerals" },
    { id: NUMERAL_FA, label: "FA", title: "اعداد فارسی" },
  ];

  return (
    <div
      role="group"
      aria-label="Numeral system"
      className={cn(
        "inline-flex w-full rounded-control border border-slate-200 bg-slate-100 p-0.5",
        collapsed && "lg:flex-col",
        className,
      )}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            title={opt.title}
            aria-pressed={active}
            onClick={() => onChange(opt.id)}
            className={cn(
              "flex-1 rounded-[0.4rem] px-2 py-1.5 text-xs font-extrabold tracking-wide transition-colors",
              active
                ? "bg-primary text-primary-foreground shadow-sm"
                : "bg-transparent text-slate-500 hover:text-slate-700",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export { NumeralSystemToggle };
